import { useFlowInfoBySessionId } from '../../../../../flows/src/api/getFlowInfo';
import {
  flowIdAskaTravelContract,
  flowIdCitizinsTravelContract,
} from '../../../../../flows/src/constants/flowIds';
import useSessionId from '../../../../../flows/src/hooks/useSessionId';

const supportedMultiQuoteContractFlows = [
  flowIdAskaTravelContract,
  flowIdCitizinsTravelContract,
];

/** This means that the contract flow supports a payload of multiple quoteIds
 * This should enable the selection buttons for a 'basket'-like functionality where you can start the contractflow from the bottombar
 */
const useIsMultiQuoteContractFlow = (): boolean => {
  const sessionId = useSessionId();
  const { data: flowInfo } = useFlowInfoBySessionId(sessionId);
  return supportedMultiQuoteContractFlows.includes(flowInfo?.next || '');
};

export default useIsMultiQuoteContractFlow;
